import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';
import { Button } from 'antd';

import {
    setRequestListSort,
    setRequestListPagination,
    setRequestListSelected
} from 'actions/requestActions';
import { request } from 'constants/routes';
import { openModalCancelRequest } from 'actions/modalActions';
import { getStatusPayload } from 'helpers/filterHelpers';
import ApprovalList from 'components/common/ApprovalList';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { fullAutoOptions } from 'constants/asyncClient';
import { notificationInterval } from 'constants/defaults';
import { defaultRequestColumns, legalRequestColumns } from 'constants/defaultColumns';
import { requestSortFields } from 'constants/defaultSorts';
import getRequestTableTemplates from './cellTemplates/requestTableTemplates';
import { getRequestList, getRequestCounters, getRequestSettings } from 'actions/asyncActions';
import CustomIcon from 'components/common/CustomIcon';
import { isLegalFieldsEnabled } from 'utils/request';

const tableConfig = {
    defaultColumns: defaultRequestColumns,
    getTemplate: getRequestTableTemplates,
    headerTranslatePrefix: 'request.headers.',
    showTableLabel: true
};

const tableLegalConfig = {
    defaultColumns: legalRequestColumns,
    getTemplate: getRequestTableTemplates,
    headerTranslatePrefix: 'request.headers.',
    showTableLabel: true
};

const dispatchToProps = {
    openModalCancel: openModalCancelRequest,

    setPagination: setRequestListPagination,
    setSort: setRequestListSort,
    setSelected: setRequestListSelected
};

@connect(({ table: { request } }) => request, dispatchToProps)
@withAsyncActions({
    getRequestSettings: getRequestSettings
        .withOptions({ dispatchOnMount: true, resetOnUnmount: false }),
    getCounters: getRequestCounters,
    getList: getRequestList
        .withPayload(getStatusPayload)
        .withOptions({ ...fullAutoOptions, pollInterval: notificationInterval })
})
@withRouteOptions
export default class RequestListView extends Component {
    static routeOptions = {
        title: 'menu.request'
    }

    getSameRequestBtn = () => {
        const { selected, history } = this.props;

        return <Button
            icon={<CustomIcon type='send' />}
            disabled={selected.length !== 1}
            onClick={() => history.push(`/add/request/${selected[0]}`)}>
            <Translate content='button.sameRequest' />
        </Button>;
    }

    render() {
        const { getList: { data, meta }, getRequestSettings: { data : settings } } = this.props;
        const isLegal = isLegalFieldsEnabled(settings);

        return (
            <ApprovalList
                sortFields={requestSortFields}
                route={request}
                status={getStatusPayload(this.props)}

                meta={meta}
                items={data.request || []}

                tableConfig={isLegal ? tableLegalConfig : tableConfig}
                buttons={this.getSameRequestBtn()}

                {...this.props}
            />
        );
    }
}
